class MinerwaStoreVisit extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('[data-visit-video]');
    if (!this.video) return;

    this.dataset.muted = 'true';

    this.querySelector('[data-sound-toggle]')?.addEventListener('click', () => {
      this.video.muted = !this.video.muted;
      this.dataset.muted = String(this.video.muted);
    });

    this.preloadObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.prime();
        this.preloadObserver.disconnect();
      },
      { rootMargin: '1000px 0px' },
    );
    this.preloadObserver.observe(this);

    this.playObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.dataset.videoActive = 'true';
          this.prime();
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
          this.video.muted = true;
          this.dataset.muted = 'true';
        }
      },
      { threshold: 0.2 },
    );
    this.playObserver.observe(this);
  }

  disconnectedCallback() {
    this.preloadObserver?.disconnect();
    this.playObserver?.disconnect();
    this.video?.pause();
  }

  prime() {
    if (!this.video || this.video.preload === 'auto') return;
    this.video.preload = 'auto';
    this.video.load();
  }
}

if (!customElements.get('minerwa-store-visit')) {
  customElements.define('minerwa-store-visit', MinerwaStoreVisit);
}
